import React from 'react'
import PropTypes from 'prop-types'
import { useHistory, Link } from 'react-router-dom'
import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/solid'

const Breadcrumbs = (props) => {
  const history = useHistory()
  const goBack = () => { history.goBack() }
  return (
    <div className='pt-6'>
      <nav className="sm:hidden" aria-label="Back">
        <a onClick={goBack} className="flex items-center text-sm font-medium text-slate-500 hover:text-clcpurple dark:text-slate-300">
          <ChevronLeftIcon className="flex-shrink-0 -ml-1 mr-1 h-5 w-5 text-slate-400" aria-hidden="true" />
          Back
        </a>
      </nav>
      <nav className="hidden sm:flex" aria-label="Breadcrumb">
        {/* "Home" as a word rather than an icon, it reads at a glance and
            matches the weight of the crumbs that follow it. */}
        <ol className="flex items-center space-x-2">
          <li>
            <Link to="/dashboard" className="text-sm font-medium text-slate-500 hover:text-clcpurple dark:text-slate-300">
              Home
            </Link>
          </li>
          { React.Children.map(props.children, (child) => {
            return (child && <li className="flex items-center space-x-2">
              <ChevronRightIcon className="flex-shrink-0 h-4 w-4 text-slate-400" aria-hidden="true" />
              { child }
            </li>)
          })}
        </ol>
      </nav>
    </div>
  )
}

export default Breadcrumbs

Breadcrumbs.propTypes = {
  disabled: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.object
  ])
}
